export default {"src":"/_next/static/media/whatsapp.1f86b298.svg","height":512,"width":448};